export default __webpack_public_path__ + "static/media/heroFaq.26f32927.jpg";